export const addClassToModalOverlayAndContent = () => {
  const modalOverlay = document.querySelector('.ReactModal__Overlay.ReactModal__Overlay--after-open');
  const modalContent = document.querySelector('.ReactModal__Content.ReactModal__Content--after-open');
  if (modalOverlay && modalContent) {
    modalOverlay.classList.add('level-item');
    modalContent.classList.add('level-item');
  }
};
